import { setPendingAction, triggerFcaNoticePrompt, triggerUnsavedChangesPrompt } from "../components/common/actions";
import store from "../store/configureStore";

export const navigateWithPrompts = ({ isFormDirty, navigateAction }) => {
    const dispatch = store && store.dispatch ? store.dispatch : null;
    if (!dispatch) {
        navigateAction();
        return;
    }

    if (isFormDirty) {
        dispatch(triggerUnsavedChangesPrompt(true));
        dispatch(setPendingAction(() => navigateAction()));
        return;
    }

    const fcaNoticeEnabled = localStorage.getItem("fcaNoticeEnabled") === "true";
    if (fcaNoticeEnabled) {
        dispatch(triggerFcaNoticePrompt(true));
        dispatch(setPendingAction(() => navigateAction()));
        return;
    }

    navigateAction();
};
